import type { ReactNode } from 'react'

import { NotificationPortal, type NotificationTone } from '@krp/ui-kit'

export type NoticeTone = NotificationTone

/**
 * Сообщение РМК в общей нижней области: не сдвигает позиции и кнопки,
 * закрывается крестиком. Тон — значок, рамка и
 * слово, а не только цвет (CLAUDE.md §7). Отказ — текстом службы дословно.
 */
export function RmkNotice({
  tone,
  title,
  text,
  hint,
  meta,
  actions,
  onClose,
}: {
  tone: NoticeTone
  title: string
  text: string | null
  /** Что делать дальше — словами, после дословного текста службы. */
  hint?: string | null
  /** Код отказа и номер запроса — для поддержки, под «Подробнее» (идентификаторов на экране нет). */
  meta?: string | null
  /** Действие сообщения («Допечатать») рядом с «Скопировать». */
  actions?: ReactNode
  onClose?: () => void
}) {
  return <NotificationPortal tone={tone} title={title} text={text} hint={hint} meta={meta} actions={actions} onClose={onClose} />
}
